import type { CountableNumber } from "@aprao/common/src/shapes/common.js";
import { makeAutoObservable } from "mobx";

import type { ShapeRevenueItemBase } from "../../shapes/ShapeRevenueGroup.js";

export class RevenueItemBaseFacade {
  constructor(readonly $model: ShapeRevenueItemBase) {
    makeAutoObservable(this);
  }

  get quantity() {
    return this.$model.quantity;
  }

  set quantity(unitCount: CountableNumber) {
    this.$model.quantity = unitCount;
  }

  get description() {
    return this.$model.description;
  }

  set description(description: string) {
    this.$model.description = description;
  }
}
